import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
	about: {
		margin: "80px",
		"& h1": {
			fontFamily: "Open Sans Condensed",
			fontSize: 54,
			marginBottom: 30,
		},
		"& p": {
			fontSize: 28,
			lineHeight: "45px",
			textAlign: "justify",
			"@media (max-width: 870px)": {
				fontSize: 24,
			},
		},
		"@media (max-width: 870px)": {
			margin: "30px",
		},
	},
});

export default function About() {
	const classes = useStyles();

	return (
		<div className={classes.about}>
			<h1>Про нас</h1>
			<p>
				Підсумовуючи цю частину доповіді, можемо зробити наступні висновки.
				"Схід" євразійських номадів мав подвійний вплив на формування
				українського національного характеру: по-перше, як гальмуючий чинник на
				шляху нормального поступу країни, по-друге, через сильну оборонну
				реакцію з боку українського народу. Проте це ще не робило самої України
				євразійською. Іншими словами, євразійська кочова стихія діяла на
				український народ ззовні, Підсумовуючи цю частину доповіді, можемо
				зробити наступні висновки. "Схід" євразійських номадів мав подвійний
				вплив на формування українського національного характеру: по-
				Підсумовуючи цю частину доповіді, можемо зробити наступні висновки.
				"Схід" євразійських номадів мав подвійний вплив на формування
				українського національного характеру: по-перше, як гальмуючий чинник на
				шляху нормального поступу країни, по-друге, через сильну оборонну
				реакцію з боку українського народу. Проте це ще не робило самої України
				євразійською. Іншими словами, євразійська кочова стихія діяла на
				український народ ззовні, Підсумовуючи цю частину доповіді, можемо
				зробити наступні висновки. "Схід" євразійських номадів мав подвійний
				вплив на формування українського національного характеру: по-
			</p>
		</div>
	);
}
